import { gql } from 'graphql-tag';

export const GET_CUSTOM_FIELD_VALUES = gql`
  query Idcc9da8085a919ef81754d65336e83db6(
    $companyId: ID!
    $customFieldId: ID!
    $customFieldValuesIds: [ID!]
    $search: String
    $includeArchivedValues: Boolean!
  ) {
    __typename
  }
`;
